import { helpers } from 'design-system';
import { EmissionDocument } from 'src/models/responseTypes/PolicyResume';

export function getMaskedMimeType(base64: string): string {
  const actualMime = helpers.extractMime(base64);
  return actualMime.includes('image') ? 'image/png' : 'application/pdf';
}

export function prepareBase64(source: string): string {
  if (helpers.isImage(source)) {
    return source.replace(/^data:image\/[a-z]+;base64,/, '');
  }
  return source.replace(/^data:application\/[a-z]+;base64,/, '');
}

export function prepareDocumentFromBase64(
  source: string,
  name: string,
): EmissionDocument {
  const mime = getMaskedMimeType(source);
  const extension = mime.includes('image') ? '.png' : '.pdf';
  return {
    id: '',
    name: `${name}${extension}`,
    content: prepareBase64(source),
    mime,
  };
}

export default prepareDocumentFromBase64;
